import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Google Analytics (gtag.js)
const GA_MEASUREMENT_ID = 'G-DFYR55M9FW';
if (typeof window !== 'undefined' && !document.getElementById('ga-gtag-script')) {
  const gtagScript = document.createElement('script');
  gtagScript.id = 'ga-gtag-script';
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    ;
    (window as any).dataLayer.push(args);
  }
  ;
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}
render(<App data-id="element-151" />, document.getElementById('root'));